import React from "react";

function RentCarMediaManagement() {
    return <div>RentCarMediaManagement</div>;
}

export default RentCarMediaManagement;
